import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import '../assets/css/icons.css';
import '../assets/css/style.css'
import logo from '../assets/images/logo.svg'
import loginbg from '../assets/images/login-bg.png';
import { SERVER_IP, PORT } from '../Server';
import axios from 'axios';
import swal from 'sweetalert';

class SimulanisLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            focusPassword: false,
            showPassword: false
        }

    }
    onChangeInput = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }
    componentDidMount() {
        // document.cookie = "useracv=Johnqq; Secure;";
        document.getElementsByClassName('xp-rightbar')[0].style.marginLeft = "0px"
    }
    onSubmit = () => {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json;charset=UTF-8',
        //         "Access-Control-Allow-Origin": "*",
        //         "password": `${this.state.password}`,
        //     }
        // };
        var data = {
            email: this.state.email,
            password: this.state.password,
            authType: 1
        }
        var _this = this;
        axios.post(`${SERVER_IP}/simulanislogin`, data,{ withCredentials: true })
            .then(function (response) {

                if (response.status === 200) {
                    if (response.data.error === false) {
                        sessionStorage.clear();
                        sessionStorage.setItem("jwt", `${response.data.token}`);
                        sessionStorage.setItem("ud", `${JSON.stringify(response.data.userinfo)}`);
                        window.location.href = "/dashboard"
                        return
                    }
                    _this.setState({ password: "", email: "" });
                    swal("Please Recheck Email and Password.")
                } else {
                    _this.setState({ password: "", email: "" });
                    swal("Please Recheck Email and Password.")

                }

            })
            .catch(function (error) {
                _this.setState({ password: "", email: "" });
                swal("Please Recheck Email and Password.")
            });
    }

    render() {
        return (
            <div>
                <div id="xp-container" className="login-container">
                    <div className="login">
                        <div className="xp-auth-box">
                            <div className="card">
                                <div className="card-body">
                                    <div className="p-3">
                                        <div className="text-center mb-3">
                                            <img src={logo} alt="logo" style={{ width: "10rem" }} />
                                            <h4 className="text-uppercase mt-4" style={{ color: "#717171", fontWeight: "500" }}>login to CONTINUE</h4>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group">
                                                <span className="l-icon">
                                                    <i className="mdi mdi-email-outline"></i>
                                                </span>
                                                <input className="in-form" type="text" name="email" onChange={this.onChangeInput} id="username" value={this.state.email} placeholder="Email" onKeyPress={event => {
                                                    if (event.key === 'Enter') {
                                                        this.refs.password.focus();
                                                    }
                                                }} required />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group">
                                                <span className="l-icon">
                                                    <i className="mdi mdi-lock"></i>
                                                </span>
                                                <span className="l-icon-eye" onClick={() => this.setState({ showPassword: !this.state.showPassword })} >
                                                        {this.state.showPassword ?
                                                            <i className="mdi  mdi-eye-off" title="Hide Password"></i>
                                                            :
                                                            <i className="mdi mdi-eye" title="Show Password"></i>
                                                        }
                                                    </span>
                                                {this.state.showPassword ?
                                                    <input className="in-form" type="text" name="password" value={this.state.password} onChange={this.onChangeInput} id="password" placeholder="Password" onKeyPress={event => {
                                                        if (event.key === 'Enter') {
                                                            this.onSubmit();
                                                        }
                                                    }} ref="password" required />
                                                    :
                                                    <input className="in-form" type="password" name="password" value={this.state.password} onChange={this.onChangeInput} id="password" placeholder="Password" onKeyPress={event => {
                                                        if (event.key === 'Enter') {
                                                            this.onSubmit();
                                                        }
                                                    }} ref="password" required />
                                                }
                                            </div>
                                        </div>
                                        {/* <div className="form-row">
                                            <div className="form-group col-6">
                                                <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" id="rememberme" />
                                                    <label className="custom-control-label" for="rememberme">Remember Me</label>
                                                </div>
                                            </div>
                                            <div className="form-group col-6 text-right">
                                                <label className="forgot-psw" data-toggle="tooltip" title="For change the Password click here!">
                                                    <a id="forgot-psw" href="javascript:void(0);">Forgot Password?</a>
                                                </label>
                                            </div>
                                        </div> */}
                                        <button onClick={this.onSubmit} className="btn btn-primary btn-rounded l-btn btn-block">Sign In</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="login-bg">
                        <img src={loginbg} alt="login" />
                    </div>
                </div>
            </div>
        )
    }
}
export default SimulanisLogin